module.exports = {"POOLS":{"TITLE":"Pool di liquidità","WARNING":"Spiacenti! Non c'è nessun pool presente. Puoi aggiungere il primo.","POOL":{"TITLE":"Informazioni Pool","ID":"Pool ID:","NAME":"Nome Pool:","TYPE":"Tipo Pool:","SENDER_INFORMATION":"Informazioni sul mittente:","COULD_CREATE_ACCOUNT_UNDER_POOL":"I tuoi clienti possono finanziare il loro conto corrente tramite questo pool di liquidità? Se sì, devi renderlo un pool pubblico e definire le istruzioni di finanziamento:","PUBLIC_PERMISSION":"Pubblico","PRIVATE_PERMISSION":"Privato"}}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/it/pool.json
// module id = 717
// module chunks = 0